"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemesMapper = void 0;
var ThemeNamesEnum_1 = require("../types/ThemeNamesEnum");
var aok_theme_1 = require("./aok/aok.theme");
var orgart_theme_1 = require("./orgart/orgart.theme");
var lidl_theme_1 = require("./lidl/lidl.theme");
var commerzbank_theme_1 = require("./commerzbank/commerzbank.theme");
var comdirect_theme_1 = require("./comdirect/comdirect.theme");
var dgv_theme_1 = require("./dgv/dgv.theme");
var bestattungendunker_theme_1 = require("./bestattungendunker/bestattungendunker.theme");
var mundrechtsanwaelte_theme_1 = require("./mundrechtsanwaelte/mundrechtsanwaelte.theme");
var drk_theme_1 = require("./drk/drk.theme");
var drv_theme_1 = require("./drv/drv.theme");
var enel_theme_1 = require("./enel/enel.theme");
var erixa_theme_1 = require("./erixa/erixa.theme");
var haditeherani_theme_1 = require("./haditeherani/haditeherani.theme");
var highcontrast_theme_1 = require("./highcontrast/highcontrast.theme");
var hsmw_theme_1 = require("./hsmw/hsmw.theme");
var memoresa_theme_1 = require("./memoresa/memoresa.theme");
var monuta_theme_1 = require("./monuta/monuta.theme");
var mymoria_theme_1 = require("./mymoria/mymoria.theme");
var november_theme_1 = require("./november/november.theme");
var proinvesta_theme_1 = require("./proinvesta/proinvesta.theme");
var schroederundpartner_theme_1 = require("./schroederundpartner/schroederundpartner.theme");
var seniorennetz_theme_1 = require("./seniorennetz/seniorennetz.theme");
var stadtleipzig_theme_1 = require("./stadtleipzig/stadtleipzig.theme");
var tiliaderm_theme_1 = require("./tiliaderm/tiliaderm.theme");
var vbselect_theme_1 = require("./vbselect/vbselect.theme");
var vig_theme_1 = require("./vig/vig.theme");
var zandura_theme_1 = require("./zandura/zandura.theme");
var wienervereinWienerstaedtische_theme_1 = require("./wienerverein_wienerstaedtische/wienervereinWienerstaedtische.theme");
var vodafone_theme_1 = require("./vodafone/vodafone.theme");
var ordnungsservice_theme_1 = require("./ordnungsservice/ordnungsservice.theme");
var ordnungswelt_theme_1 = require("./ordnungswelt/ordnungswelt.theme");
var signaliduna_theme_1 = require("./signaliduna/signaliduna.theme");
var podcastOidhl_theme_1 = require("./podcastOidhL/podcastOidhl.theme");
/**
 * Essentially this an object that acts as a big switch
 */
exports.ThemesMapper = (_a = {},
    _a[ThemeNamesEnum_1.ThemeNamesEnum.MEM] = memoresa_theme_1.memoresaTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.MEMORDER] = memoresa_theme_1.memoresaTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.MEMHERITAGE] = memoresa_theme_1.memoresaTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.MEMEMERGENCY] = memoresa_theme_1.memoresaTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.AOK] = aok_theme_1.aokTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.ORGART] = orgart_theme_1.orgartTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.PODCAST_OIDHL] = podcastOidhl_theme_1.podcastOidhl,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.COMDIRECT] = comdirect_theme_1.comdirectTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.COMMERZBANK] = commerzbank_theme_1.commerzbankTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.DGV] = dgv_theme_1.dgvTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.DRK] = drk_theme_1.drkTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.DRV] = drv_theme_1.drvTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.ENEL] = enel_theme_1.enelTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.ERIXA] = erixa_theme_1.erixaTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.HADITEHREANI] = haditeherani_theme_1.haditeheraniTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.HIGHCONTRAST] = highcontrast_theme_1.highcontrastTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.HSNW] = hsmw_theme_1.hsmwTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.SIGNALIDUNA] = signaliduna_theme_1.signalidunaTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.MONUTA] = monuta_theme_1.monutaTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.MYMORIA] = mymoria_theme_1.mymoriaTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.ORDNUNGSWELT] = ordnungswelt_theme_1.ordnungsweltTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.ORDNUNGSSERVICE] = ordnungsservice_theme_1.ordnungsserviceTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.NOVEMBER] = november_theme_1.novemberTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.LIDL] = lidl_theme_1.lidlTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.PROINVESTA] = proinvesta_theme_1.proinvestaTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.SCHROEDERUNDPARTNER] = schroederundpartner_theme_1.schroederundpartnerTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.SENIORENNETZ] = seniorennetz_theme_1.seniorennetzTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.STADTLEIPZIG] = stadtleipzig_theme_1.stadtleipzigTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.TILIADERM] = tiliaderm_theme_1.tiliadermTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.VBSELECT] = vbselect_theme_1.vbselectTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.VIG] = vig_theme_1.vigTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.VODAFONE] = vodafone_theme_1.vodafoneTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.WIENERVEREIN] = wienervereinWienerstaedtische_theme_1.wienervereinWienerstaedtischeTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.WIENERSTAEDTISCHE] = wienervereinWienerstaedtische_theme_1.wienervereinWienerstaedtischeTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.WIENERVEREINWIENERSTAEDTISCHE] = wienervereinWienerstaedtische_theme_1.wienervereinWienerstaedtischeTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.WIENERVEREIN_WIENERSTAEDTISCHE] = wienervereinWienerstaedtische_theme_1.wienervereinWienerstaedtischeTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.ZANDURA] = zandura_theme_1.zanduraTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.BESTATTUNGENDUNKER] = bestattungendunker_theme_1.bestattungendunkerTheme,
    _a[ThemeNamesEnum_1.ThemeNamesEnum.MUNDRECHTSANWAELTE] = mundrechtsanwaelte_theme_1.mundrechtsanwaelteTheme,
    _a);
